import './style.scss'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import Button from 'components/UI/Button'
import Icon from 'components/UI/Icon'
import * as Types from 'types'
import checkmark from 'img/checkmark.svg'
import warning from 'img/warning.svg'
import { formatAddress } from 'utilities/address'
import trash from 'img/trash.svg'

class AddressListItem extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            deleted: false,
        }

        this.handleSelect = this.handleSelect.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCancelDelete = this.handleCancelDelete.bind(this)
    }

    handleSelect() {
        const { isCurrent, onSelect } = this.props

        if (!isCurrent) {
            onSelect && onSelect()
        }
    }

    handleDelete(event) {
        const { onDelete } = this.props

        event.stopPropagation()
        this.setState({ deleted: true })
        onDelete && onDelete()
    }

    handleCancelDelete(event) {
        const { onCancelDelete } = this.props

        event.stopPropagation()
        this.setState({ deleted: false })
        onCancelDelete && onCancelDelete()
    }

    render() {
        const { deleted } = this.state
        const { address, isCurrent, canDeliver, enableDelete, onDelete, onSelect, t } = this.props
        const className = classNames({
            'address-list-item': true,
            'address-list-item__active': isCurrent && !deleted,
            'address-list-item__invalid': isCurrent && !deleted && !canDeliver,
            'address-list-item__deleted': deleted,
            'address-list-item__deletable': !!onDelete,
            'address-list-item__selectable': !isCurrent && !!onSelect,
        })

        if (deleted) {
            return (
                <div className={className}>
                    {t('addressListRemoved', { address: formatAddress(address) })}
                    <br />
                    <Button
                        variant="text"
                        className="address-list-item__cancel-delete-btn"
                        onClick={this.handleCancelDelete}
                    >
                        {t('addressListUndoRemove')}
                    </Button>
                </div>
            )
        }

        return (
            <div className={className} onClick={this.handleSelect}>
                <div className="address-list-item__data">
                    <div className="address-list-item__name">
                        {address.firstName} {address.lastName}
                    </div>
                    <div className="address-list-item__street">
                        {formatAddress(address)}
                        <br />
                        <small className="address-list-item__city">
                            {address.zip} {address.city}
                        </small>
                        <br />
                        {address.co && (
                            <small className="address-list-item__co">C/O {address.co}</small>
                        )}
                    </div>
                </div>
                <div className="address-list-item__actions">
                    {!!onDelete && (
                        <Button
                            variant="text"
                            className="address-list-item__delete-btn"
                            onClick={this.handleDelete}
                            disabled={!enableDelete}
                        >
                            <Icon svg={trash} />
                        </Button>
                    )}
                    {isCurrent && canDeliver && (
                        <Icon className="address-list-item__icon" svg={checkmark} size={'medium'} />
                    )}
                    {isCurrent && !canDeliver && (
                        <Icon className="address-list-item__icon" svg={warning} />
                    )}
                </div>
            </div>
        )
    }
}

AddressListItem.propTypes = {
    address: Types.address,
    isCurrent: PropTypes.bool,
    canDeliver: PropTypes.bool,
    enableDelete: PropTypes.bool,
    onDelete: PropTypes.func,
    onCancelDelete: PropTypes.func,
    onSelect: PropTypes.func,
    t: PropTypes.func,
}

export default withTranslation()(AddressListItem)
